import { StylesConfig } from "react-select";

export const selectCustomStyles: StylesConfig = {
  control: (provided) => ({
    ...provided,
    padding: "17px 5px 3px 5px",
    borderRadius: 4,
    borderColor: "#DDE0E4",
    boxShadow: "none",
  }),
  menu: (provided) => ({
    ...provided,
    marginTop: 0,
    boxShadow: "none",
    borderRadius: 0,
    border: "1px solid #ced4da",
    borderTop: "none",
    backgroundColor: "white",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 4px",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#F3F6FD",
    color: "#6D819B",
    fontSize: "14px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#6D819B",
    fontSize: "14px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    ":hover": {
      backgroundColor: "#F3F6FD",
      color: "#6D819B",
    },
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  clearIndicator: (provided) => ({ ...provided, paddingTop: "2px" }),
  dropdownIndicator: (provided) => ({
    ...provided,
    marginTop: "-8px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#3E4957",
  }),
};

export const selectLabelStyles = {
  color: "#8B929A",
  transformOrigin: "0px 0px",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  paddingTop: "1rem",
  paddingLeft: "12px",
  zIndex: 2,
  transform: "scale(0.85) translateY(-0.5rem) translateX(0.15rem)",
};
